<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>
    <lsn-table-cell class="sl-return-table__column sl-return__reference">
        {{ oReturn.id_commande }}
    </lsn-table-cell>

    <lsn-table-cell class="sl-return-table__column sl-return__serial-number">
        {{ oReturn.numero_sn }}
    </lsn-table-cell>

    <lsn-table-cell class="sl-return-table__column sl-return__label">
        {{ label }}
    </lsn-table-cell>

    <lsn-table-cell class="sl-return-table__column sl-return__price">
        {{ priceWithTax }}
    </lsn-table-cell>

    <lsn-table-cell class="sl-return-table__column sl-return__currency">
        {{ oReturn.fk_reference_monnaie }}
    </lsn-table-cell>
</template>


<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>
import LsnTableCell from '@/components/LsnTable/LsnTableCell.vue';

export default
{
    name: 'ReturnLineSummary',

    components:
    {
        LsnTableCell,
    },

    props:
    {
        oReturn:
        {
            type:     Object,
            required: true,
        },
    },

    computed:
    {
        label()
        {
            let out = '';

            // Build the string: "prototype[ modeVente[ | refPatient[ | refCommande]]]"
            if(this.oReturn.prototype ?? false)
            {
                out += this.oReturn.prototype;

                if(this.oReturn.modeVente ?? false)
                {
                    out += ' ' + this.oReturn.modeVente;
                }

                if(this.oReturn.refPatient ?? false)
                {
                    out += ' | ' + this.oReturn.refPatient;
                }

                if(this.oReturn.refCommande ?? false)
                {
                    out += ' | ' + this.oReturn.refCommande;
                }
            }
            // Build the string: "case1[ modeVente]"
            else if(this.oReturn.case1 ?? false)
            {
                out += this.oReturn.case1;

                if(this.oReturn.modeVente ?? false)
                {
                    out += ' ' + this.oReturn.modeVente;
                }
            }

            return out;
        },

        priceWithTax()
        {
            return this.$f(parseFloat(this.oReturn.display_price).toFixed(2), 'thousand');
        },
    },
};
</script>


<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss" scoped>

</style>
